export default {
  // Common
  defaultDishName: 'Default Dish',
  login: 'Login',
  logout: 'Logout',
  cancel: 'Cancel',
  confirm: 'Confirm',
  delete: 'Delete',
  edit: 'Edit',
  save: 'Save',
  update: 'Update',
  create: 'Create',
  add: 'Add',
  loading: 'Loading...',
  
  // Main Page - Top Navigation
  title: 'AI Prompts Sharing Dish',
  adminEntry: 'Admin Portal',
  toggleSidebar: 'Toggle Sidebar',
  
  // Main Page - Left Panel
  dishManagement: 'Dish Management',
  officialDish: 'Official Prompt Dish',
  favoriteDishes: 'Favorite Dishes',
  shareCodeSearch: 'Share Code Search',
  myDishes: 'My Created Dishes',
  addDish: 'Add Dish',
  createFirstDish: 'Create First Dish',
  noDishesYet: 'No dishes created yet',
  pleaseLoginFirst: 'Please login to view your dishes',

  // Main Page - Center Content Area
  loadingPromptData: 'Loading AI Prompt data...',
  officialPromptDish: 'Official Prompt Set Dish',
  shareCodeSearchPlaceholder: 'Enter share code',
  searchDish: 'Search Dish',
  showAll: 'Show All',
  noPromptData: 'No AI Prompt data available',
  pleaseUploadFile: 'Please upload HT_AIprompt.xlsx file first',
  goToAdminUpload: 'Go to Admin Upload',
  
  // Custom Dish View
  promptList: 'Prompt List',
  addPrompt: 'New Prompt',
  noDishSelected: 'Please select a dish',
  selectDishHint: 'Click on a dish on the left to view its contents',
  emptyDishTitle: 'This dish has no prompts yet',
  emptyDishHint: 'Start adding your exclusive AI prompts!',
  addFirstPrompt: 'Add First Prompt',
  loadingPrompts: 'Loading prompts...',
  noPromptsFound: 'No prompts found',

  // Favorite Feature
  loadingFavorites: 'Loading favorites...',
  noFavoritesYet: 'No favorite dishes yet',
  favoritedAt: 'Favorited At',
  removeFavorite: 'Remove Favorite',
  addToFavorite: 'Add to Favorites',
  backToFavorites: 'Back to Favorites',
  items: 'items',
  close: 'Close',

  // Preview Panel
  promptDetails: 'Prompt Details',
  editPrompt: 'Edit Prompt',
  sendToHT: 'Import to AI Assistant',
  
  // Form Field Labels
  promptCategory: 'Prompt Category',
  promptPurpose: 'Prompt Purpose',
  howToUse: 'How to Use',
  usage: 'Usage',
  sourceData: 'Source Data',
  conditionalPrompt: 'Conditional Prompt',
  promptContent: 'Prompt Content',
  expectedOutput: 'Expected Output',
  followUpActions: 'Follow-up Actions',
  personalNotes: 'Personal Notes',
  creator: 'Creator',
  unknown: 'Unknown',
  
  // Category Options
  categories: {
    score: 'Score',
    general: 'General',
    quiz: 'Quiz',
    custom: 'Custom',
    pickup: 'Pickup',
    mindMap: 'Mind Map'
  },
  
  // Add Dish Modal
  addDishModal: {
    title: 'Add AI Prompt Dish',
    nameLabel: 'Dish Name',
    nameRequired: 'Dish Name *',
    namePlaceholder: 'Enter dish name',
    descriptionLabel: 'Dish Description',
    descriptionPlaceholder: 'Enter dish description (optional)',
    isPublicLabel: 'Public dish (viewable by other users)',
    creating: 'Creating...',
    confirmCreate: 'Confirm Create'
  },
  
  // Edit Dish Modal
  editDishModal: {
    title: 'Edit & Share',
    updating: 'Updating...',
    confirmUpdate: 'Update',
    defaultNameNotEditable: 'Default dish name cannot be modified',
    dishSharing: 'Dish Sharing Code',
    publishing: 'Publishing...',
    publishShare: 'Publish & Share',
    closeShare: 'Close Sharing'
  },
  
  // Add Prompt Modal
  addPromptModal: {
    title: 'Add AI Prompt',
    categoryLabel: 'Prompt Category *',
    categoryPlaceholder: 'Please select a category',
    purposeLabel: 'Prompt Purpose *',
    purposePlaceholder: 'e.g., Generate middle school math geometry unit curriculum outline',
    usageLabel: 'Usage',
    usagePlaceholder: 'Enter suggestions for using this AI prompt, e.g., modify grade and unit name',
    sourceDataLabel: 'Source Data',
    sourceDataPlaceholder: 'Enter suggested data content to attach when using this AI prompt, e.g., student Q&A answers',
    sourceDataTypeLabel: 'Source Data Type',
    sourceDataTypeText: 'Text',
    sourceDataTypeImage: 'Image',
    conditionalPromptLabel: 'Conditional Prompt *',
    conditionalPromptPlaceholder: 'e.g., Based on [unit name] and [grade level], generate a curriculum outline including learning objectives, teaching activities, and assessment methods',
    expectedOutputLabel: 'Expected Output',
    expectedOutputPlaceholder: 'e.g., Structured curriculum outline with teaching objectives, key concepts, activity design, and assessment standards',
    followUpActionsLabel: 'Follow-up Actions',
    followUpActionsPlaceholder: 'e.g., Review outline content, adjust teaching activity sequence, prepare materials',
    personalNotesLabel: 'Personal Notes',
    personalNotesPlaceholder: 'e.g., Suitable for geometry units, can be combined with physical teaching aids',
    adding: 'Adding...',
    confirmAdd: 'Confirm Add'
  },
  
  // Edit Prompt Modal
  editPromptModal: {
    title: 'Edit AI Prompt',
    categoryLabel: 'Prompt Category *',
    categoryPlaceholder: 'Please select a category',
    purposeLabel: 'Prompt Purpose *',
    purposePlaceholder: 'e.g., Generate middle school math geometry unit curriculum outline',
    usageLabel: 'Usage',
    usagePlaceholder: 'Enter suggestions for using this AI prompt, e.g., modify grade and unit name',
    sourceDataLabel: 'Source Data',
    sourceDataPlaceholder: 'Enter suggested data content to attach when using this AI prompt, e.g., student Q&A answers',
    sourceDataTypeLabel: 'Source Data Type',
    sourceDataTypeText: 'Text',
    sourceDataTypeImage: 'Image',
    conditionalPromptLabel: 'Conditional Prompt *',
    conditionalPromptPlaceholder: 'e.g., Based on [unit name] and [grade level], generate a curriculum outline including learning objectives, teaching activities, and assessment methods',
    expectedOutputLabel: 'Expected Output',
    expectedOutputPlaceholder: 'e.g., Structured curriculum outline with teaching objectives, key concepts, activity design, and assessment standards',
    followUpActionsLabel: 'Follow-up Actions',
    followUpActionsPlaceholder: 'e.g., Review outline content, adjust teaching activity sequence, prepare materials',
    personalNotesLabel: 'Personal Notes',
    personalNotesPlaceholder: 'e.g., Suitable for geometry units, can be combined with physical teaching aids',
    updating: 'Updating...',
    confirmUpdate: 'Update'
  },
  
  // Delete Confirmation Modal
  deleteConfirmModal: {
    dishTitle: 'Confirm Delete Dish',
    promptTitle: 'Confirm Delete Prompt',
    deleting: 'Deleting...',
    confirmDelete: 'Confirm Delete'
  },
  
  // Admin Login Page
  adminLogin: {
    title: 'Admin Login',
    backButton: '← Back',
    adminVerification: 'Admin Verification',
    subtitle: 'Please enter admin credentials to continue',
    userIdLabel: 'User ID',
    passphraseLabel: 'Admin Passphrase',
    passphrasePlaceholder: 'Enter admin passphrase',
    verifying: 'Verifying...',
    verifyAndLogin: 'Verify & Login',
    enterPassphrase: 'Please enter admin passphrase',
    wrongPassphrase: 'Wrong admin passphrase, please try again',
    verificationFailed: 'Verification failed, please try again later',
    noLoginInfo: 'Login information not found, please login again',
    noAdminPermission: 'You do not have admin permission',
    invalidLoginInfo: 'Invalid login information, please login again'
  },
  
  // Admin Upload Page
  adminUpload: {
    title: 'Admin File Upload',
    backButton: '← Back',
    adminBadge: 'Admin',
    uploadTitle: 'AI Prompt File Upload',
    uploadSubtitle: 'Support Excel multi-language files, drag & drop or click to upload',
    currentFileLabel: '📄 Current File:',
    downloadCurrentFile: '(Click to download current version)',
    uploadWarning: '⚠️ Uploading new file will overwrite existing HT_AIprompt.xlsx file',
    dropZoneText: 'Drag files here or',
    selectFile: 'Select File',
    supportedFormat: 'Supported format: .xlsx',
    startUpload: 'Start Upload',
    uploading: 'Uploading...',
    onlyXlsxSupported: 'Only Excel (.xlsx) format files are supported',
    fileTooLarge: 'File size cannot exceed 10MB',
    uploadSuccess: 'AI Prompt Excel file upload completed',
    uploadFailed: 'File upload failed, please try again',
    noValidLanguageData: 'No valid language data found in Excel file',
    cannotGetUploadPermission: 'Cannot obtain upload permission'
  },
  
  // Success/Error Messages
  messages: {
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed',
    logoutSuccess: 'Logout successful',
    logoutFailed: 'Logout failed',
    adminVerificationSuccess: 'Admin verification successful!',
    favorited: 'Added to favorites',
    unfavorited: 'Removed from favorites',
    autoFavorited: 'Automatically added to favorites',
    favoriteFailed: 'Failed to add to favorites',
    unfavoriteFailed: 'Failed to remove favorite',
    loadFavoritesFailed: 'Failed to load favorite list',
    loadDetailFailed: 'Failed to load favorite detail',
    collectionUnavailable: 'This dish has been set to private or deleted by the owner',
    pleaseRemoveFavorite: 'Please manually remove this favorite',
    dishCreated: 'Dish created successfully!',
    dishUpdated: 'Dish updated successfully!',
    dishDeleted: 'Dish deleted',
    promptAdded: 'Prompt added successfully!',
    promptUpdated: 'Prompt updated successfully!',
    promptDeleted: 'Prompt deleted',
    copied: 'Content copied to clipboard',
    copyFailed: 'Copy failed',
    pleaseSelectDishFirst: 'Please select a dish first',
    pleaseLoginToAddDish: 'Please login before adding dish',
    pleaseLoginToAddPrompt: 'Please login before adding prompt',
    pleaseLogin: 'Please login first',
    pleaseEnterDishName: 'Please enter dish name',
    pleaseFillRequiredFields: 'Please fill in required fields',
    noDataChanges: 'No data changes, no need to save',
    dishNotPublic: 'The dish owner has set this as private',
    missingRequiredInfo: 'Missing required information',
    dishNameRequired: 'Dish Name *',
    dishIdError: 'Dish ID error',
    promptIdError: 'Missing prompt ID',
    loadSuccess: 'Successfully loaded {count} AI Prompt categories',
    noValidCategoryData: 'No valid category data found in the file',
    pleaseSelectPlateAndConfirmData: 'Please select a plate and confirm the prompt data',
    promptAddedToPlate: 'Prompt successfully added to "{plateName}" plate',
    addPromptToPlateFailed: 'Failed to add prompt: {error}',
    loadFailed: 'Loading failed: {error}',
    cannotReadFile: 'Cannot read file',
    createDishFailed: 'Failed to create dish: {error}',
    updateDishFailed: 'Failed to update dish: {error}',
    checkFailed: 'Check failed: {error}',
    addPromptFailed: 'Failed to add prompt: {error}',
    updatePromptFailed: 'Failed to update prompt: {error}',
    sentToHT: 'Prompt data has been sent to HT',
    outputToConsole: 'Prompt data has been output to Console (non-WebView environment)',
    sendFailed: 'Send failed, please check Console',
    dishPublished: 'Dish has been published for sharing',
    dishShareClosed: 'Dish sharing has been closed',
    noShareLinkToCopy: 'No share link to copy',
    shareLinkCopied: 'Share code copied to clipboard',
    copyLinkFailed: 'Copy failed, please copy manually',
    publishFailed: 'Publish failed: {error}',
    closeShareFailed: 'Close sharing failed: {error}'
  },

  // Share Prompt to Plate
  shareToPlate: {
    title: 'Please Select a Plate to Add To',
    selectPlate: 'Select Plate',
    selectPlaceholder: 'Please select a plate',
    promptContent: 'Prompt Content',
    adding: 'Adding...',
    addToPlate: 'Add',
    cancel: 'Cancel',
    success: 'Prompt has been successfully added to "{plateName}" plate',
    noPlateSelected: 'Please select a plate and confirm prompt data',
    noPromptData: 'No shared prompt data received',
    loginRequired: 'Please login first to share prompts to plates',
    noPlatesAvailable: 'You don\'t have any plates yet, please create a plate first',
    addFailed: 'Failed to add prompt: {error}',
    // Preview Area Labels
    previewLabels: {
      promptPurpose: 'Prompt Purpose',
      promptCategory: 'Prompt Category',
      usage: 'Usage',
      sourceData: 'Source Data',
      sourceDataType: 'Source Data Type',
      conditionalPrompt: 'Conditional Prompt Content',
      expectedOutput: 'AI Output',
      followUpActions: 'Follow-up Actions',
      personalNotes: 'Personal Notes'
    }
  },
  
  // Common Tooltips
  tooltips: {
    edit: 'Edit',
    delete: 'Delete'
  },
  
  // Copy Content Labels
  copyLabels: {
    purpose: 'Prompt Purpose',
    category: 'Prompt Category',
    usage: 'Usage',
    conditionalPrompt: 'Conditional Prompt',
    expectedOutput: 'Expected Output'
  },
  
  // Delete Confirmation Messages
  deleteConfirm: {
    dishWithPrompts: 'Dish “{name}” contains {count} prompts.\nDeleting the dish will also delete all internal prompts, this action cannot be undone.\nAre you sure you want to continue?',
    dishWithoutPrompts: 'Are you sure you want to delete dish “{name}”? This action cannot be undone.',
    prompt: 'Are you sure you want to delete prompt “{name}”? This action cannot be undone.'
  },
  
  // Success Message Templates
  successMessages: {
    dishDeletedWithPrompts: 'Dish “{name}” and its {count} internal prompts have been completely deleted',
    dishDeleted: 'Dish “{name}” has been deleted',
    promptDeleted: 'Prompt has been deleted'
  },
  
  // Error Messages
  errors: {
    onlyXlsxSupported: 'Only Excel (.xlsx) format files are supported',
    fileTooLarge: 'File size cannot exceed 10MB',
    fileTooLargeWithSize: 'File size cannot exceed 10MB, current file size: {size}',
    excelParseFailed: 'Excel parsing failed: {error}',
    fileReadFailed: 'File reading failed',
    cannotGetUploadPermission: 'Cannot obtain upload permission',
    uploadFailed: 'Upload failed: {error}',
    sasTokenExpired: 'SAS Token has expired, please re-obtain',
    uploadPermissionInsufficient: 'Insufficient upload permission, please re-obtain SAS Token',
    containerNotExists: 'Container does not exist',
    dishNotExistsOrDeleted: 'Dish does not exist or has been deleted',
    noPermissionToDelete: 'No permission to delete this dish',
    deleteDishFailed: 'Failed to delete dish: {error}',
    deletePromptFailed: 'Failed to delete prompt: {error}',
    generateDownloadUrlFailed: 'Failed to generate download URL',
    tokenParseFailed: 'Token parsing failed',
    completeAdminVerificationFirst: 'Please complete admin verification first',
    loginInfoInvalid: 'Login information is invalid, please login again',
    unknownError: 'Unknown error',
    fileUploadFailed: 'File upload failed, please try again',
    noValidLanguageData: 'No valid language data found in Excel file',
    shareCodeSearchFailed: 'Search failed, please check if the share code is correct, or the user has set it to private',
    shareCodeNotFound: 'Cannot find the dish corresponding to this share code'
  }
};